import { StyledBroadsiderFilters } from './BroadsiderFilters.styled';
import { IconButton, SelectableButton } from '../';
import { theme } from '../../theme';

const BroadsiderFilters = ({ figure, onAvatavi = () => {}, onAr = () => {}, onTt = () => {}, onInsta = () => {} }) => {
  return (
    <StyledBroadsiderFilters>
      <div className='bs-filters-content-wrapper'>
        <div className='bs-filters-content'>
          <div className='bs-filters-title-holder'>
            <img className='bs-filters-logo' src='/assets/skull.svg' />
            <div className='bs-filters-title'>Filters</div>
          </div>
          <div className='bs-filters-rows'>
            <div className='bs-filters-row'>
              <IconButton onClick={() => onAvatavi(figure)} animated={false} disabled={figure.isSideload()}>
                <div className='bs-filters-button-content'>
                  <div>Avatavi</div>
                  <img style={{paddingBottom: '6px'}} src='/assets/qr.svg'/>
                </div>
              </IconButton>
              <SelectableButton
                selected={false}
                isIconButton={true}
                backgroundOverwrite={theme.baseOrange}
                borderOverwrite='rgba(0, 0, 0, .16)'
                onClick={() => {
                  onInsta();
                }}
                img='/assets/insta.svg'/> 
              <SelectableButton
                selected={false}
                disabled={true}
                isIconButton={true}
                backgroundOverwrite={theme.baseRed}
                borderOverwrite='rgba(0, 0, 0, .16)'
                onClick={() => {
                  //onTt();
                }}
                img='/assets/tt.svg'/> 
              </div>
              <div className='bs-filters-row'>
              <IconButton onClick={() => onAr(figure)} animated={false} backgroundOverwrite='white' disabled={figure.isSideload()}>
                <div className='bs-filters-button-content'>
                  <div>View in AR</div>
                  <img style={{paddingBottom: '6px'}} src='/assets/qr.svg'/>
                </div>
              </IconButton>
            </div>
          </div>
        </div>
      </div>
      <div className='bs-filters-corner bs-filters-corner-tl' />
      <div className='bs-filters-corner bs-filters-corner-tr' />
      <div className='bs-filters-corner bs-filters-corner-bl' />
      <div className='bs-filters-corner bs-filters-corner-br' />
    </StyledBroadsiderFilters>
  )
};

export default BroadsiderFilters;
